import { EntityState, buildEntityState } from '../EntityState';

export type MyBuilderState = EntityState<MyBuilderActionState>;

export const buildMyBuilderState = (data: Partial<MyBuilderState> = {}) =>
  buildEntityState<MyBuilderActionState>(data);

export enum MyBuilderActionState {
  ArmyListCreation = 0,
  ArmyListFormat = 1,
  FolderCreation = 3,
  ContestCreation = 4,
  ArsenalArmyCreation = 5,
  BookCreation = 6,
}
